import React from 'react';

import Head from 'next/head';

import { getHostname } from 'utils/environment';

interface IMeta {
  title?: string;
  url?: string;
  video?: string;
  description?: string;
  image?: string;
}
export const Meta = ({
  title = 'Butter | Workshops as smooth as butter',
  url = '',
  video,
  description = 'Butter is a video conferencing tool that empowers facilitators to run interactive, buttery smooth online workshops!',
  image = 'https://files.butter.us/meta-image.png',
}: IMeta) => {
  const regexp = /(http|ftp|https):\/\/([\w+?\.\w+])+([a-zA-Z0-9\~\!\@\#\$\%\^\&\*\(\)_\-\=\+\\\/\?\.\:\;\'\,]*)?/g;

  const urlMask = url?.match(regexp) ? url : `${getHostname()}${url}`;
  const imageMask = image?.match(regexp) ? image : `${getHostname()}${image}`;
  return (
    <Head>
      {title && (
        <>
          <title>{title}</title>
          <meta name="title" content={title} />
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
        </>
      )}
      {video && (
        <>
          <meta property="og:video" content={video} />
          <meta property="twitter:player" content={`${url}/iframe`} />
        </>
      )}
      {description && (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
          <meta property="twitter:description" content={description} />
        </>
      )}
      {urlMask && (
        <>
          <link rel="canonical" href={urlMask} />
          <meta property="og:url" content={urlMask} />
        </>
      )}
      {imageMask && (
        <>
          <meta property="og:image" content={imageMask} />
          <meta property="twitter:image" content={imageMask} />
          <meta name="twitter:card" content="summary_large_image" />
        </>
      )}
    </Head>
  );
};
